/**
 * API Configuration
 * Easily switch between mock and real API for development
 */

// API Configuration
export const USE_MOCK_API = process.env.REACT_APP_USE_MOCK_API === 'true' || false;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

// API Endpoints
export const API_ENDPOINTS = {
  // Inventory endpoints
  INVENTORY: {
    SEARCH: '/inventory/search',
    SUGGESTIONS: '/inventory/suggestions',
    PRODUCT_DETAILS: '/inventory/products',
  },

  // Orders endpoints
  ORDERS: {
    LIST: '/orders',
    DETAILS: '/orders',
    UPDATE_STATUS: '/orders/status',
    UPDATE_CHECKBOX: '/orders/checkbox',
    SAVE_CHANGES: '/orders/changes',
  },

  // Smart Order Capture endpoints
  SMART_ORDER: {
    EXTRACT_FILE: '/smart-order/extract-file',
    EXTRACT_TEXT: '/smart-order/extract-text',
    HISTORY: '/smart-order/history',
    EXTRACTION_BY_ID: '/smart-order/extraction',
    SAVE_ORDER: '/smart-order/save',
  },
};

// Development indicator
export const isDevelopment = process.env.NODE_ENV === 'development';
